import {getAbout} from '@/api/about'

export default {
    namespaced: true,
    state:{
        data: '',
        loading: false,
    },
    mutations:{
        SET_LOADING(state, payload){
            state.loading = payload;
          },
          SET_DATA(state,payload){
            state.data = payload;
          }
    },
    actions:{
        async fetchAbout(ctx){
            ctx.commit('SET_LOADING', true)
            const res = await getAbout()
            if(res) ctx.commit('SET_DATA',res)
            ctx.commit('SET_LOADING', false)
        }
    }
}